<style scoped>
.releaseNoteHeader {
  display: block;
  font-size: 1.2em;
  margin-top: 0.8em;
  margin-bottom: 0em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}
</style>
<template>
  <div style="min-height: 100vh">
    <h2 class="ml-5 mt-3 mb-2">Release Notes:</h2>
    <div class="pl-5 pr-5">
      <hr />
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: palevioletred">New Feature</b-badge
        ><a style="color: grey; font-size: 0.8em">29 November 2022</a>
      </div>
      <div class="releaseNoteHeader">Custom Authentication Pages</div>
      <p>Business and Enterprise clients can now have customised Authentication pages</p>
      <ul>
        <li>The configuration must be done by insdi</li>
        <li>There is a single tenant authentication structure across all links for the template</li>
      </ul>
    </div>
    <div class="pl-5 pr-5">
      <hr />
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: rgb(85, 187, 250)">Enhancement</b-badge
        ><a style="color: grey; font-size: 0.8em">26 November 2022</a>
      </div>
      <div class="releaseNoteHeader">Custom Submit To Names per link</div>
      <p>
        Users can now configure a custom name in the final "Submit To" button per link. This is
        useful should you want to generate a link per business partner and have the final submit
        button indicate their name rather than the tenant's name.
      </p>
    </div>
    <div class="pl-5 pr-5">
      <hr />
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: palevioletred">New Feature</b-badge
        ><a style="color: grey; font-size: 0.8em">3 November 2022</a>
      </div>
      <div class="releaseNoteHeader">Authentication is now optional (but still the default)</div>

      <p>
        insdi now allows users to switch off the authentication requirement on links. Simply go to
        the links page and set "Authentication Required" to "No". If authentication is disabled,
        clicking on the insdi link will take the user straight to the form without prompting for any
        form of authentication.
      </p>
      <p>The following restrictions apply to forms accessed without authentication:</p>
      <ul>
        <li>
          Users are unable to access their drafts or submitted forms accessed without authentication
        </li>
        <li>Users are unable to share forms</li>
      </ul>
      <p>
        On submission on an unauthenticated link, the same notification process continues, with all
        recipients receiving email notification and they are able to access forms submitted to them
        via <a href="https://home.insdi.com" target="_blank"> home.insdi.com</a>
      </p>
      <div>
        <hr />
        <div class="form-line">
          <b-badge class="my-2 mr-2" style="background-color: palevioletred">New Feature</b-badge
          ><a style="color: grey; font-size: 0.8em">20 October 2022</a>
        </div>
        <div class="releaseNoteHeader">Email authenticated users can share to mobile numbers</div>

        <p>
          Only email authenticated users can share draft forms. We now allow users to share forms to
          mobile numbers. With the form open, navigate to Options -> Share. Enter the name and
          select to share with a mobile phone number.
        </p>
        <p>Note:</p>
        <ul>
          <li>The full international number must be used. For example +27841234567</li>
          <li>
            Users authenticating using their mobile numbers cannot share the form as only email
            authentications can share draft forms to other users. So do not share to a phone number
            if that person is expected to share it forward again.
          </li>
        </ul>
      </div>
      <div>
        <hr />
        <div class="form-line">
          <b-badge class="my-2 mr-2" style="background-color: rgb(85, 187, 250)"
            >Enhancement</b-badge
          ><a style="color: grey; font-size: 0.8em">12 October 2022</a>
        </div>
        <div class="releaseNoteHeader">Form header and group text (mobile devices)</div>
        <p>
          THe header text colour and group name colour will alternate between white and black
          depending on the heading / group colour. Users can use a light or dark header colour to
          match their company's logo and the text colour will adjust automatically.
        </p>
      </div>
      <div>
        <hr />
        <div class="form-line">
          <b-badge class="my-2 mr-2" style="background-color: rgb(85, 187, 250)"
            >Enhancement</b-badge
          ><a style="color: grey; font-size: 0.8em">27 September 2022</a>
        </div>
        <div class="releaseNoteHeader">CSV extracts include comment indicator</div>
        <p>
          The indicator &lt;&lt;COMMENT&gt;&gt; is added to any field value in the CSV extract where
          a comment has been provided. User need to read the comment in the submitted pdf or json
          file synced to cloude storage.
        </p>
      </div>
      <div>
        <hr />
        <div class="form-line">
          <b-badge class="my-2 mr-2" style="background-color: rgb(85, 187, 250)"
            >Enhancement</b-badge
          ><a style="color: grey; font-size: 0.8em">20 September 2022</a>
        </div>
        <div class="releaseNoteHeader">Force authentication type on reshare links</div>
        <p>
          If a form is shared, the reshare link will only display the authentication type that the
          link was shared to. Eg. if a user shares a form to an email address, the link will only
          ask for an email address to authenticate.
        </p>
      </div>
      <div>
        <hr />
        <div class="form-line">
          <b-badge class="my-2 mr-2" style="background-color: rgb(85, 187, 250)"
            >Enhancement</b-badge
          ><a style="color: grey; font-size: 0.8em">27 August 2022</a>
        </div>
        <div class="releaseNoteHeader">Field Id duplicate warning</div>
        <p>The interface will warn users if they have given two fields the same fieldId.</p>
      </div>
      <div>
        <hr />
        <div class="form-line">
          <b-badge class="my-2 mr-2" style="background-color: rgb(85, 187, 250)"
            >Enhancement</b-badge
          ><a style="color: grey; font-size: 0.8em">6 August 2022</a>
        </div>

        <div class="releaseNoteHeader">Options in tables are now draggable</div>
        <p>
          Users can reorder option lists in tables by dragging the individual options to other
          positions.
        </p>
        <hr />
      </div>
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: palevioletred">New Feature</b-badge
        ><a style="color: grey; font-size: 0.8em"> March 2023</a>
      </div>
      <div class="releaseNoteHeader">Deactivation of Templates</div>
      <p>
        Many of our insdi clients have a growing list of form Templates and some of these Templates
        are no longer in use. We have added a toggle button next to each Template to allow you to
        easily deactivate or activate a Template. You can then choose to filter the list of
        Templates based on their status
      </p>

      <p>
        When deactivating a Template, a "Cannot Deactivate Template" message will appear if the
        Template still has active Template Links associated with it. You will need to first
        de-activate these links before de-activating the Template. This will prevent form users from
        accessing forms where the Template is no longer active.
      </p>
    </div>
    <hr />

    <div class="pl-5 pr-5">
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: rgb(85, 187, 250)">Enhancement</b-badge
        ><a style="color: grey; font-size: 0.8em">March 2023</a>
      </div>
      <div class="releaseNoteHeader">Form Re-activation</div>
      <p>
        One of the most requested features is the ability for a user to re-activate a form they have
        already submitted, and this is finally available on insdi.
      </p>

      <p>
        Users may have submitted a form only to realise they left something important off it, or
        maybe they have been requested to add further information or documents to it.
      </p>

      <p>
        Now any person who was part of the form's journey can simply find the form on
        https://home.insdi.com, select the options menu and choose the reactivate menu item. They
        can then make the changes and re-submit the form and the usual form submission journey is
        followed as before.
      </p>
    </div>
    <hr />

    <div class="pl-5 pr-5">
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: palevioletred">New Feature</b-badge
        ><a style="color: grey; font-size: 0.8em">March 2023</a>
      </div>
      <div class="releaseNoteHeader">New Insdi Support Portal</div>
      <p>
        In our mission to provide you with great insdi service, we have upgraded our support system.
        The new support system can be accessed at
        <a href="https://support.insdi.com">https://support.insdi.com</a>
      </p>
      <p>
        We highly recommend signing up if you haven't already so that you can log support requests,
        track support items and see your support history.
      </p>
      <p>
        Remember you can always log support tickets by sending an email to support@insdi.com too.
      </p>
      <p>
        The Support Portal also has a growing Knowledge Base with articles that teach and inform you
        with regards to numerous insdi-related features and topics. Within our support portal, we
        have recently created an insdi Community area where you can see other insdi user's ideas,
        vote for ideas or share your own ideas. We look forward to seeing you there!
      </p>
    </div>
    <hr />

    <div class="pl-5 pr-5">
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: rgb(85, 187, 250)">Enhancement</b-badge
        ><a style="color: grey; font-size: 0.8em">April 2023</a>
      </div>
      <div class="releaseNoteHeader">Logo's on Form Submission Reports</div>
      <p>
        When a user submits a form, a PDF report gets generated showing the fields and values that
        were submitted. The PDF submission report has been primarily geared towards back-office
        staff and so has been fairly bland in appearance, however the reality is that the user who
        submitted the information may also want a copy of this report, as may any intermediate user
        of the form and so it was felt that some form of visual company identity was necessary on
        this report.
      </p>
      <p>
        With this in mind, insdi now automatically shows the Template's logo as part of a cover page
        banner on the submission report. As an alternative, the logo specified for a Share Link (the
        same logo used on the Share Link's landing page) can also be used if insdi admins prefer to
        set this on a per Share Link basis.
      </p>
    </div>
    <hr />

    <div class="pl-5 pr-5">
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: rgb(85, 187, 250)">Enhancement</b-badge
        ><a style="color: grey; font-size: 0.8em">April 2023</a>
      </div>
      <div class="releaseNoteHeader">Active forms Alert Message</div>
      <p>
        If you are an insdi user that needs to review or finalise forms that have been submitted to
        you or shared with you, you will now see a warning message at the top of your insdi home
        page stating how many Active forms you currently have. These are forms that have started
        their form journey but have not been fully completed or submitted yet and require your
        attention.
      </p>
    </div>
    <hr />

    <div class="pl-5 pr-5">
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: palevioletred">New Feature</b-badge
        ><a style="color: grey; font-size: 0.8em">April 2023</a>
      </div>
      <div class="releaseNoteHeader">Form Field Presets for Share Links</div>
      <p>
        There are times when you would like set certain fields based on the Share Link being used.
        For example, you may use a different Share Link for each branch of your business or you may
        have set up Share Links for intermediaries that use your forms and you may want those branch
        or intermediary details automatically filled in when a user opens the form.
      </p>
    </div>
    <hr />

    <div class="pl-5 pr-5">
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: palevioletred">New Feature</b-badge
        ><a style="color: grey; font-size: 0.8em">April 2023</a>
      </div>
      <div class="releaseNoteHeader">Request Form Submission Report</div>
      <p>
        insdi Administrators can now specify whether Form Users may request a copy of the form
        submission report when submitting a form.
      </p>
    </div>
    <hr />

    <div class="pl-5 pr-5">
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: palevioletred">New Feature</b-badge
        ><a style="color: grey; font-size: 0.8em">August 2023</a>
      </div>
      <div class="releaseNoteHeader">Insdi AI Integration</div>
      <p><b>AI Feature #1: insdi Co-pilot</b></p>
      <p>
        Adding rules and calculations to the insdi form templates can be tricky! even though we’ve
        tried to keep it simple by using Excel-like rules and calculations not everyone is (or wants
        to be) an Excel formula guru.
      </p>
      <p>
        Bring on… insdi Copilot - it’s built into the insdi Admin Portal and when you need to create
        a rule to show or hide a field or group of fields or you need to add a calculation, just ask
        the insdi Copilot to assist.
      </p>
      <p>
        insdi Admins, once you’ve had a chance to try it out, please send us your feedback (positive
        or negative) or suggestions via support@insdi.com.
      </p>
      <p><b>AI feature #2: insdi Document Q&A</b></p>
      <p>
        We are currently testing an AI-driven Document Q&A capability also known as "chat to
        document" on the insdi platform and we’d love to get your feedback (and demo it to you too,
        if you’re interested).
      </p>
      <p>
        The main idea is that anyone filling in one of your business forms would be able to ask
        questions relating to the form or the product/service you offer or the process they must
        follow using plain english questions and the answers would come out of the document(s) you
        linked to that form
      </p>
      <p>
        The document might contain frequently asked questions or policy wording or product
        information or a how-to guide - it’s entirely up to you.
      </p>
    </div>
    <hr />

    <div class="pl-5 pr-5">
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: palevioletred">New Feature</b-badge
        ><a style="color: grey; font-size: 0.8em">August 2023</a>
      </div>
      <div class="releaseNoteHeader">New insdi Landing Pages</div>
      <p>
        We will be rolling some improvements to the current landing pages. The phone authentication
        option will now sit alongside the email option rather than the current (less user friendly)
        check box approach.
      </p>
    </div>
    <hr />

    <div class="pl-5 pr-5">
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: palevioletred">New Feature</b-badge
        ><a style="color: grey; font-size: 0.8em">August 2023</a>
      </div>
      <div class="releaseNoteHeader">New insdi Status Filter - insdi Home</div>
      <p>
        We have added a new filter option on home.insdi.com<br />You are now able to filter forms on
        their 'Status'. By clicking the arrows next to the 'Status' filter, forms will be grouped
        accordingly (Active, Completed, Draft and Recalled).
      </p>
    </div>
    <hr />

    <div class="pl-5 pr-5">
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: rgb(85, 187, 250)">Enhancement</b-badge
        ><a style="color: grey; font-size: 0.8em">August 2023</a>
      </div>
      <div class="releaseNoteHeader">Attachment Toggle on TempShare</div>
      <p>
        When creating a link, you now have the option to allow attachments to be included in email
        notifications. When this option is selected, data is included in email notifications to form
        owners. If this option is set to 'No', data can only be obtained via the insdi portals
        and/or the OneDrive Cloud Integrations.
      </p>
    </div>
    <hr />

    <div class="pl-5 pr-5">
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: rgb(85, 187, 250)">Enhancement</b-badge
        ><a style="color: grey; font-size: 0.8em">August 2023</a>
      </div>
      <div class="releaseNoteHeader">Share Link Owners receiving email notifications</div>
      <p>
        insdi will now allow Share Link Owners to receive email notifications after a form
        submission without having the submission report attached to the email.<br />
        The submission report can be downloaded from home.insdi.com or can be sync'd to OneDrive, if
        configured.
      </p>
    </div>
    <hr />

    <div class="pl-5 pr-5">
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: rgb(85, 187, 250)">Enhancement</b-badge
        ><a style="color: grey; font-size: 0.8em">August 2023</a>
      </div>
      <div class="releaseNoteHeader">TempShare Special Characters</div>
      <p>
        When setting up a new link, the name that is entered into the 'Share Name' field is the name
        used to create the link URL. Therefore, any special characters other than the following
        cannot be used: _ - ()
      </p>
    </div>
    <hr />

    <div class="pl-5 pr-5">
      <div class="form-line">
        <b-badge class="my-2 mr-2" style="background-color: rgb(85, 187, 250)">Enhancement</b-badge
        ><a style="color: grey; font-size: 0.8em">August 2023</a>
      </div>
      <div class="releaseNoteHeader">Return to sender</div>
      <p>
        insdi’s digital forms are great for secure sharing and sometimes several people are involved
        in completing a single form.
      </p>
      <p>
        Based on feedback from insdi user’s who share the form with each other, we’ve realised the
        word “Submit” at the end of the form makes most users think it’s the final submission of the
        form back to it’s source, when in fact it may just be sending the form back to the previous
        person who shared it with them.
      </p>
      <p>
        To make pressing this button less daunting, we have changed the button text to “Return to
        (sender name)”. Only the person actually performing the final submit back the form
        originator will see the words “Submit to (name)”.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReleaseNotes',
  data() {
    return {
      userJourneys: [],
      userJourneyFields: [
        { key: 'createdAtUTC', sortable: true, sortDirection: 'desc' },
        { key: 'templateCategory', label: 'Category', sortable: true },
        //  { key:'templateName', sortable: true, thStyle: { width: "100px" }},
        { key: 'formShareName', label: 'Link Name', sortable: true },
        { key: 'user_name', sortable: true },
        { key: 'action', sortable: true },
        { key: 'formIdentifierValue', sortable: true, thStyle: { width: '25%' } },
        //  { key:'createdBy.auth_username', label: 'User',sortable: true},
        //  { key:'formId',sortable: true, thStyle: { width: "150px" }},
        // { key:'user_identifier',sortable: true},
        //   { key:'description', thStyle: { width: "30%" }}
        { key: 'show_details', label: '', thStyle: { width: '90px' } }
      ],
      downloadFields: [
        { key: 'createdAtUTC' },
        { key: 'templateCategory' },
        { key: 'templateName' },
        { key: 'formShareName', label: 'Link Name' },
        { key: 'user_name' },
        { key: 'action' },
        { key: 'formIdentifierValue' },
        //  { key:'createdBy.auth_username', label: 'User',sortable: true},
        { key: 'formId' },
        //  { key:'user_identifier'},
        { key: 'description' }
      ],
      tenant: '',
      searchTenant: '',
      tenantList: [],
      startPeriod: '',
      endPeriod: '',
      customRange: false,
      rowsPerExtract: 250,
      moreDataLastDate: '',
      tableLoading: false,
      durationSelected: 0,
      moreData: false,
      rowcntOptions: [
        { value: 5, text: '5 rows per page' },
        { value: 25, text: '25 rows per page' },
        { value: 50, text: '50 rows per page' },
        { value: 100, text: '100 rows per page' },
        { value: 250, text: '250 rows per page' }
      ],
      options: [
        { value: 30, text: '30 min' },
        { value: 60, text: '1 hour' },
        { value: 360, text: '6 hours' },
        { value: 1440, text: '24 hours' },
        { value: 10080, text: '1 week' }
      ]
    }
  },
  methods: {}
}
</script>
